<sb-dashboard-widget [title]="title() | translate" [isLoading]="isLoading()" [fixedHeight]="false">
  @if (chart()) {
    <sb-chart class="p-3" [type]="chart().type" [data]="chart().data" [options]="chart().options" [height]="height()" />
  }
</sb-dashboard-widget>
